import { PDFDocument, StandardFonts, rgb } from 'pdf-lib'
import fontkit from '@pdf-lib/fontkit'

import CalibriBold from './fonts/calibri-bold.ttf'
import CalibriNormal from './fonts/calibri-normal.ttf'
import SOATemplate from './template-jan-30-26.pdf'
import computeXBasedOnAlignment from '../computeXBasedOnAlignment'

import netBillingToWords from '../netBillingToWords'

import urlToBlob from 'utils/urlToBlob'
import generateBillingDetails from '../generateBillingDetails'

import generateCutoff from 'utils/generateCutoff'
import { format } from 'date-fns'
let templateMap = {
    billed_to: {
        x: 106,
        y: 628,
        size: 12,
        fontWeight: 'bold'
    },
    store: {
        x: 106,
        y: 615,
        size: 12
    },


    /*

    amount_in_words: {
        x: 79,
        y: 469,
        size: 10,
        maxWidth: 250,
        wordBreaks: [" "]
    },
    */



    /*
    cutoff: {
        x: 320,
        y: 520,
        size: 11,
        width: 271,
        alignment: 'center',
        fontColor: 'white'
    },*/


    /*
    total_billing: {
        x: 452,
        y: 509,
        size: 10,
        alignment: 'right',
        width: 80
    },


    
    */

    net_billing: {
        x: 415,
        y: 440,
        size: 15,
        alignment: 'right',
        width: 100,
        fontWeight: 'bold'
    },

    date: {
        x: 415,
        y: 613,
        size: 10
    },

    date_settlement: {
        x: 260,
        y: 301,
        width: 160,
        alignment: 'center',
        size: 10,
    },

    gross_billing: {
        x: 415,
        y: 575,
        size: 10,
        width: 100,
        fontWeight: 'bold',
        alignment: 'right'
    },
    admin_cost: {
        x: 415,
        y: 560,
        size: 10,
        alignment: 'right',
        width: 100
    },
    cutoff: {
        x: 100,
        y: 531,
        size: 10,
        width: 174,
        alignment: 'center'
    },

    sum_billing: {
        x: 415,
        y: 548,
        size: 10,
        alignment: 'right',
        width: 100,
        fontWeight: 'bold'
    },
    vat: {
        x: 415,
        y: 530,
        size: 10,
        alignment: 'right',
        width: 100
    },

    withholding_tax: {
        x: 415,
        y: 515,
        size: 10,
        alignment: 'right',
        width: 100
    },
    net_billing_computed: {
        x: 415,
        y: 500,
        size: 12,
        alignment: 'right',
        width: 100,
        fontWeight: 'bold'
    },


    meal_allowance: {
        x: 415,
        y: 484,
        size: 10,
        alignment: 'right',
        width: 100
    },

    salary_deduction: {
        x: 415,
        y: 470,
        size: 10,
        alignment: 'right',
        width: 100
    },

    other_deductions: {
        x: 415,
        y: 455,
        size: 10,
        alignment: 'right',
        width: 100
    },
    amount_in_words: {
        x: 100,
        y: 470,
        size: 10,
        width: 200,
        maxWidth: 200,
        fontWeight: 'bold',
        wordBreaks: [" "],
        lineHeight: 10,
    },




    soa_number: {
        x: 415,
        y: 628,
        size: 10,
        fontWeight: 'bold'
    },


    payroll_head: {
        x: 60,
        y: 187,
        size: 10,
        fontWeight: 'bold'
    },

    payroll_head_text: {
        x: 60,
        y: 170,
        size: 10,
    },

    payroll_manager: {
        x: 60,
        y: 90,
        size: 10,
        fontWeight: 'bold'
    },

    payroll_manager_text: {
        x: 60,
        y: 77,
        size: 10,
    },


    director_finance_dept: {
        x: 315,
        y: 93,
        size: 10,
        fontWeight: 'bold'
    },

    president_text: {
        x: 315,
        y: 77,
        size: 10,
    }



    /*
    vat: {
        x: 10,
        y: 10,
    },
    withholding_tax: {
        x: 10,
        y: 10
    }*/
}


export default async function generateSOA7starjasem(generatedBillingDetails = {}) {
    let amountInWords = await netBillingToWords(generatedBillingDetails.net_billing)

    let newBillingDetails = {
        ...generatedBillingDetails,
        amount_in_words: amountInWords,
        date: format(generatedBillingDetails.createdAt, 'MMMM dd, yyyy'),
        denomination: "PHP",
        payroll_manager_text: 'Payroll Manager',
        payroll_head_text: 'Payroll Head',
        president_text: 'Managing Director',
        cutoff: generateCutoff(generatedBillingDetails.payroll_from, generatedBillingDetails.payroll_to)
    }

    try {
        let downloadedPDF = await urlToBlob(SOATemplate)
        let downloadedPDFBlob = await downloadedPDF.arrayBuffer()
        const templateDoc = await PDFDocument.load(downloadedPDFBlob)
        templateDoc.registerFontkit(fontkit)
        const downloadedBoldFont = await (await urlToBlob(CalibriBold)).arrayBuffer()
        const downloadedNormalFont = await (await urlToBlob(CalibriNormal)).arrayBuffer()

        const boldFont = await templateDoc.embedFont(downloadedBoldFont)
        const normalFont = await templateDoc.embedFont(downloadedNormalFont)

        let pages = templateDoc.getPages()
        let firstPage = pages[0]

        Object.keys(newBillingDetails).forEach((key) => {
            let mappingDetails = templateMap[key]

            if (mappingDetails) {
                let text = String(newBillingDetails[key])//String(key)

                if (typeof newBillingDetails[key] === 'number') {
                    text = Number(newBillingDetails[key]).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                }

                let font = mappingDetails.fontWeight === 'bold' ? boldFont : normalFont
                let textWidth = mappingDetails.fontWeight === 'bold' ? boldFont.widthOfTextAtSize(text, mappingDetails.size) : normalFont.widthOfTextAtSize(text, mappingDetails.size)
                let x = computeXBasedOnAlignment(mappingDetails.alignment, mappingDetails.x, textWidth, mappingDetails.width)



                if (mappingDetails?.fontColor === 'white')
                    firstPage.setFontColor(rgb(1, 1, 1))
                else
                    firstPage.setFontColor(rgb(0, 0, 0))

                firstPage.drawText(text, {
                    ...mappingDetails,
                    x: x,
                    font: font
                })





                //draw rectangles for debugging

                /*
                 if (mappingDetails.alignment === 'right' || mappingDetails.alignment === 'center') {
                     console.log('right alignment', key)
 
 
 
                     firstPage.drawRectangle({
                         ...mappingDetails,
                         height: 10,
                         width: textWidth,
                         borderColor: rgb(0, 1, 0),
                         borderWidth: 2
                     })
 
                     firstPage.drawRectangle({
                         ...mappingDetails,
                         height: 10,
                         borderColor: rgb(1, 0, 0),
                     })
                 } 
 
                 */




            }
        })




        const pdfBytes = await templateDoc.save()

        let blob = new Blob([pdfBytes], {
            type: 'application/pdf'
        });

        let blobURL = `${URL.createObjectURL(blob)}`;

        window.open(blobURL)
        fetch(blobURL)

    } catch (err) {
        console.log(err)
    }
}
